import React, { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type TableHeaderItemProps = {
  className?: string;
  text: ReactNode | string;
};
export const TableHeaderItem: FC<TableHeaderItemProps> = ({ text, className }) => {
  return (
    <div
      className={twMerge(
        'border-#F2F2F2 flex items-center gap-2 border-b-[1px] bg-gray-50 px-2 py-3',
        className,
      )}
    >
      <span className="whitespace-nowrap text-label-md font-medium text-[#172335]">{text}</span>
    </div>
  );
};
